'use strict';

var React = require('react');

var SvgFinancesMinor = function SvgFinancesMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.755 3.145a1.25 1.25 0 0 1 1.008.015l5.654 2.591a1 1 0 0 1 .583.91v.59a1 1 0 0 1-1 1h-.5v3.749h.25a.75.75 0 0 1 0 1.5h-11.5a.75.75 0 0 1 0-1.5h.25v-3.75h-.5a1 1 0 0 1-1-1v-.584a1 1 0 0 1 .61-.921l6.145-2.6Zm.483 1.425-5.154 2.18h9.911l-4.757-2.18Zm3.762 7.43v-3.75h-1.5v3.75h1.5Zm-5-3.75h2v3.75h-2v-3.75Zm-1.5 3.75v-3.75h-1.5v3.75h1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.25a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5h-11.5a.75.75 0 0 1-.75-.75Z"
  }));
};
SvgFinancesMinor.displayName = "FinancesMinor";

exports.SvgFinancesMinor = SvgFinancesMinor;
